import { render, staticRenderFns } from "./CatalogMenuItemForm.vue?vue&type=template&id=94320da6&scoped=true"
import script from "./CatalogMenuItemForm.vue?vue&type=script&lang=js"
export * from "./CatalogMenuItemForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenuItemForm.vue?vue&type=style&index=0&id=94320da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94320da6",
  null
  
)

export default component.exports